export default {
  user: {},
  userProfile: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/initialState.js